import { render, staticRenderFns } from "./selfStudy.vue?vue&type=template&id=3bb8fcf6&scoped=true"
import script from "./selfStudy.vue?vue&type=script&lang=js"
export * from "./selfStudy.vue?vue&type=script&lang=js"
import style0 from "./selfStudy.vue?vue&type=style&index=0&id=3bb8fcf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb8fcf6",
  null
  
)

export default component.exports